import { Link } from "react-router-dom";
import { CONTENT_ROUTES } from "../data/registry";
import ArticleBody from "./ArticleBody";
import "./templates.css";

/** Which content type each hub lists. */
const HUB_TYPE = {
  "/guides": "guide",
  "/compare": "compare",
  "/tools": "tool",
  "/hi": "hindi",
  "/research": "research",
  "/gyms": "vertical",
};

/** A section index: the hub's own intro (if any), then a card per page of its type. */
export default function HubPage({ entry, chunk, entries = CONTENT_ROUTES }) {
  const type = HUB_TYPE[entry.path];
  const items = entries.filter((e) => e.type === type);

  return (
    <section className="tpl tpl--hub" lang={entry.lang === "hi-IN" ? "hi" : undefined}>
      <div className="container tpl__inner">
        <header className="tpl__head">
          <h1 className="t-display-2">{entry.h1}</h1>
          <p className="t-lead tpl__lead">{entry.description}</p>
        </header>
        {chunk && <ArticleBody html={chunk.html} slug={entry.path} lang={entry.lang} />}
        <ul className="tpl-cards">
          {items.map((e) => (
            <li key={e.path} className="tpl-card">
              <h2 className="tpl-card__title">
                <Link to={e.path}>{e.h1}</Link>
              </h2>
              <p className="tpl-card__text">{e.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
